/**
 * feat-107 Slice B — "⧉ Paste from Notion" launcher (the trigger + wizard host).
 *
 * Slice A's editor renders this via the `renderImporter(ctx, variant)` hook in
 * two slots: the app-bar (`variant='appbar'`) and the no-Lessons empty state
 * (`variant='empty'`). Clicking opens the PasteImportWizard modal; on a
 * successful import the wizard calls `ctx.onImported` so the editor refetches.
 *
 * Owned by frontend-b. Wires into Slice A's marked SLICE B WIRE-IN seam in
 * QuizContentManagement (default export).
 */

import React, { useState } from 'react';
import type { ImporterContext, ImporterVariant } from '../importerHook';
import { PasteImportWizard } from './PasteImportWizard';

export interface PasteImportLauncherProps {
  ctx: ImporterContext;
  variant: ImporterVariant;
}

export function PasteImportLauncher({ ctx, variant }: PasteImportLauncherProps): React.ReactElement {
  const [open, setOpen] = useState(false);

  const trigger =
    variant === 'empty' ? (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 bg-white border border-coral text-coral font-display font-semibold rounded-full px-5 py-2.5 text-sm hover:bg-coral-light"
      >
        ⧉ Paste from Notion
      </button>
    ) : (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1.5 bg-gold-light text-gold font-display font-semibold rounded-full px-4 py-2 text-sm hover:brightness-95"
      >
        ⧉ Paste from Notion
      </button>
    );

  return (
    <>
      {trigger}
      {open && (
        <PasteImportWizard
          tenantId={ctx.tenantId}
          units={ctx.units}
          selectedUnitId={ctx.selectedUnitId}
          onClose={() => setOpen(false)}
          onImported={ctx.onImported}
        />
      )}
    </>
  );
}

export default PasteImportLauncher;
